import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SovosSlidingPanel from 's1-ui/sovos-sliding-panel/SovosSlidingPanel';
import SovosTabs from 's1-ui/sovos-tabs/SovosTabs';
import Tab from '@material-ui/core/Tab';
import InvoiceLinesGrid from './invoiceLinesGrid/InvoiceLinesGridConnector';
import InvoiceHeaderDetail from './InvoiceHeaderDetail';
import TaxCalculationTabContent from './taxCalculationTabContent/TaxCalculationTabContentConnector';
import { purple } from 's1-ui/themes/sovos-colors';
import InvoiceEditorSlidingPanel from './invoiceEditor/InvoiceEditorSlidingPanelConnector';

const styles = {
  content: {
    padding: 0
  },
  tabsIndicator: {
    backgroundColor: purple
  },
  tabTextColorPrimary: {
    color: purple,
    '&.selected': {
      color: purple
    }
  }
};

const invoiceTab = 'invoices';
const taxCalcTab = 'taxCalc';

class InvoiceLinesSlidingPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: invoiceTab,
      showTabs: false,
      openInvoiceEditorSlidingPanel: false
    };
  }

  componentDidMount() {
    this.checkUserPermissions(this.props.userPermissions);
  }
  
  componentWillReceiveProps(nextProps) {
    if ( this.props.userPermissions !== nextProps.userPermissions ) {
      this.checkUserPermissions(nextProps.userPermissions);
    }
  }

  checkUserPermissions(userPermission) {
    const isInternalAdmin = userPermission.find( ({name}) => name === 'UTM_R_LOG' );
    this.setState({ showTabs:  isInternalAdmin !== undefined });
  }

  handleEditInvoiceClick = () => {
    this.setState({ openInvoiceEditorSlidingPanel: true });
  };

  handleCloseInvoiceEditorSlidingPanel = () => {
    this.setState({ openInvoiceEditorSlidingPanel: false });
  }

  onCloseSlidingPanel = () => {
    this.setState({ selectedTab: invoiceTab });
    this.props.invoiceLinesFiltersActions.clearAllInvoiceLineFilters();
    this.props.onCloseSlidingPanel();
  };

  render () {
    const {
      classes,
      open,
      selectedInvoice,
      periodId,
      invoiceId,
      fetchingInvoice
    } = this.props;
    const { showTabs, selectedTab, openInvoiceEditorSlidingPanel } = this.state;
    return (
      <React.Fragment>
        <SovosSlidingPanel
          open={ open }
          onClose={ this.onCloseSlidingPanel }
          baseWidth={ '1230px' }
          classes={ classes }
        >
          {
            showTabs &&
            <SovosTabs
              value={ selectedTab }
              onChange={ (e, selectedTab) => this.setState({ selectedTab }) }
              classes={ classes }
            >
              <Tab label="Invoices" value={ invoiceTab }/>
              <Tab label="Tax Calculation" value={ taxCalcTab }/>
            </SovosTabs>
          }
          {
            (selectedTab === invoiceTab && showTabs || !showTabs) &&
            <React.Fragment>
              <InvoiceHeaderDetail
                invoice={ selectedInvoice }
                closeSlidingPanel={ this.onCloseSlidingPanel }
                isInvoiceLine={ false }
                fetchingInvoice={ fetchingInvoice }
                onEditClick={ this.handleEditInvoiceClick }
              />
              <InvoiceLinesGrid
                periodId={ periodId }
                invoice={ selectedInvoice }
                invoiceId={ invoiceId }
                closeSlidingPanel={ this.onCloseSlidingPanel }
              />
            </React.Fragment>
          }
          {
            selectedTab === taxCalcTab && showTabs &&
            <TaxCalculationTabContent invoice={ selectedInvoice } />
          }
        </SovosSlidingPanel>
        <InvoiceEditorSlidingPanel
          open={ openInvoiceEditorSlidingPanel }
          onClose={ this.handleCloseInvoiceEditorSlidingPanel }
          invoiceNumber={ invoiceId }
          invoice={ selectedInvoice }
        />
      </React.Fragment>
    );
  }
}

InvoiceLinesSlidingPanel.propTypes = {
  open: PropTypes.bool.isRequired,
  onCloseSlidingPanel: PropTypes.func.isRequired,
  classes: PropTypes.object,
  periodId: PropTypes.string.isRequired,
  selectedInvoice: PropTypes.object,
  invoiceId: PropTypes.number.isRequired,
  userPermissions: PropTypes.array,
  fetchingInvoice: PropTypes.bool,
  invoiceLinesFiltersActions: PropTypes.shape({
    clearAllInvoiceLineFilters: PropTypes.func,
    fetchInvoiceById: PropTypes.func
  })
};

export default withStyles(styles)(InvoiceLinesSlidingPanel);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/InvoiceLinesSlidingPanel.js